import * as fp from 'lodash/fp';
import { Observable, rx } from '@shared/rx';
import {
  makeOnControlChangedOperator,
  IOnControlChangedOperator,
  IValueMakers,
} from './on-control-changed-base';
import { fixFormStatus } from './fix-form-status';
import { ENgFormStatus } from '@shared/types/enums';

const valueMakers: IValueMakers<boolean> = {
  withDefaultValue: (control): Observable<boolean> =>
    control.statusChanges.pipe(
      rx.startWith(control.status),
      fixFormStatus(control),
      rx.filter(
        fp.includes(fp.placeholder, [
          ENgFormStatus.Valid,
          ENgFormStatus.Invalid,
        ]),
      ),
      rx.map(fp.isEqual(ENgFormStatus.Valid)),
      rx.distinctUntilChanged(),
    ),
  noDefaultValue: (control): Observable<boolean> =>
    control.statusChanges.pipe(
      fixFormStatus(control),
      rx.filter(
        fp.includes(fp.placeholder, [
          ENgFormStatus.Valid,
          ENgFormStatus.Invalid,
        ]),
      ),
      rx.map(fp.isEqual(ENgFormStatus.Valid)),
      rx.distinctUntilChanged(),
    ),
};

export const onControlIsValidChanged: IOnControlChangedOperator<boolean> =
  makeOnControlChangedOperator(valueMakers);
